"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ventilerPrixDeMenu = ventilerPrixDeMenu;
const errors_1 = require("../errors");
const allocate_1 = require("../money/allocate");
const cents_1 = require("../money/cents");
// Ventilation du prix d'un menu entre les taux de ses composants (spec
// 2026-10-01 §3). Un prix forfaitaire couvrant des biens à des taux différents
// doit être réparti ; la méthode retenue est le prorata des prix de vente des
// composants vendus seuls. Le taux du menu ne sert plus que de repli : aucun
// composant pesant (menu vide, variations absentes, prix tous nuls).
//
// Fonction pure, partagée par la caisse (`computeItem`) et le serveur
// (`OrderHelpers.getOrderTaxes`, commandes non signées) : une seule règle.
function ventilerPrixDeMenu(amount, components, fallbackTax) {
    (0, cents_1.assertCents)(amount, 'ventilerPrixDeMenu.amount');
    if (amount < 0) {
        throw new errors_1.InvalidAmountError(`ventilerPrixDeMenu : montant négatif, reçu : ${amount}`);
    }
    const buckets = new Map();
    for (const component of components) {
        (0, cents_1.assertCents)(component.weight, 'ventilerPrixDeMenu.weight');
        if (component.weight < 0) {
            throw new errors_1.InvalidAmountError(`ventilerPrixDeMenu : poids négatif, reçu : ${component.weight}`);
        }
        if (component.weight === 0)
            continue;
        const bucket = buckets.get(component.tax.id);
        if (bucket === undefined) {
            buckets.set(component.tax.id, { tax: component.tax, weight: component.weight });
            continue;
        }
        if (bucket.tax.ratePercent !== component.tax.ratePercent) {
            throw new errors_1.TaxMismatchError(`ventilerPrixDeMenu : taux incohérent pour la taxe ${component.tax.id} (${bucket.tax.ratePercent} vs ${component.tax.ratePercent})`);
        }
        bucket.weight += component.weight;
    }
    // Menu offert : la ligne doit rester nommable avec un taux (noyau fiscal),
    // celui du menu.
    if (buckets.size === 0 || amount === 0)
        return [{ tax: fallbackTax, amount }];
    const sorted = [...buckets.values()].sort((a, b) => b.tax.ratePercent - a.tax.ratePercent || a.tax.id.localeCompare(b.tax.id));
    const amounts = (0, allocate_1.allocateProportionally)(amount, sorted.map((bucket) => bucket.weight));
    // Une part à 0 (montant trop petit pour tous les taux) ne produirait qu'une
    // ligne fiscale vide : on l'omet. Au moins une part est > 0 puisque
    // amount > 0.
    return sorted
        .map((bucket, index) => ({ tax: bucket.tax, amount: amounts[index] ?? 0 }))
        .filter((part) => part.amount > 0);
}
